module.exports = __webpack_public_path__ + "home-hero-Rdy0u9m.jpg";